<template>
    <div>
        <div class="container">
            <div class="row">
                <TitleArea :title="this.$t('menus.zkpsh.zkp.title')" />
                <div class="row">
                    <div class="col">
                        <p>
                           {{ this.$t('menus.zkpsh.zkp.content') }}
                        </p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-4 col-md-6 card shadow-sm p-3 mb-5 bg-body rounded">
                        <h4>{{ this.$t('menus.zkpsh.zkp.contact.title') }}</h4>
                        <h5>Liridonë Kozmaqi Hajdaraj</h5>
                        <p> {{ this.$t('menus.zkpsh.zkp.contact.position') }}</p>                      
                          <p>{{ this.$t('menus.zkpsh.zkp.contact.tel') }}</p>
                            <p v-html="this.$t('menus.zkpsh.zkp.contact.email')"></p>
                              <p> {{ this.$t('menus.zkpsh.zkp.contact.address') }}</p>
                           
                        
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import TitleArea from '@/components/share/TitleArea.vue';

export default {
  components: { TitleArea },
    data(){
        return{

        }
    },
    componnta:{
        TitleArea
    }
}
</script>
<style lang="">
    
</style>